import React, { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "./../../../../../store/userSlice";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import ReNewPopUpUpdate from "./popups/RenewPopup";
import AuthorizationPopUp from "./popups/AuthorizePopUp";
import DocumentsDownloadPopup from "./popups/DocumentsDownloadPopup";
import nodeinstance from "../../../../../nodeInstance";
import SmartDownloadPagination from "../../../../../components/SmartDataTable/SmartDownloadPagination";

export default function ListIqamaRenewList({
  token,
  setLen,
  callBack
}) {
  const [Popup, setPopUp] = useState(false);
  const [authPopup, setAuthPopup] = useState(false);
  const [documentPopUp, setDocumentPopUp] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [documents, setdocument] = useState([]);
  const [empData, setEmpData] = useState({});
  const [trigger, setTrigger] = useState(false);

  // Filters
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  const [selectNational, setSelectNational] = useState("");
  const [expiryDays, setExpiryDays] = useState("");

  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchData, setSearchData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const columns = useMemo(() => [
    { key: "sno", title: "S.NO.", sortable: false },
    { key: "selection", title: "SELECT", sortable: false },
    { key: "emp_id", title: "EMPLOYEE ID" },
    { key: "sadaad_notes", title: "SADAAD NOTES" },
    { key: "border_number", title: "BORDER NUMBER" },
    { key: "nationality", title: "NATIONALITY" },
    { key: "visa_provider", title: "VISA PROVIDER" },
    { key: "sponsor_id", title: "SPONSOR ID" },
    { key: "client", title: "CLIENT" },
    { key: "iqama_number", title: "IQAMA NUMBER" },
    { key: "iqama_issue_date", title: "IQAMA ISSUE DATE" },
    { key: "iqama_expiry_date_g", title: "IQAMA EXPIRY DATE (G)" },
    { key: "iqama_expiry_date_h", title: "IQAMA EXPIRY DATE (H)" },
    { key: "iqama_aging_days", title: "IQAMA AGEING DAYS" },
    { key: "iqama_valid_days", title: "IQAMA VALID DAYS" },
    { key: "tenure", title: "TENURE" },
    { key: "renewal_request_date", title: "RENEWAL REQUEST DATE" },
    { key: "renewal_authorization_date", title: "RENEWAL AUTHORIZATION DATE" },
    { key: "sadaad_generation_date", title: "SADAAD GENERATION DATE" },
    { key: "sadaad_payment_date", title: "SADAAD PAYMENT DATE" },
    { key: "status", title: "STATUS" },
  ], []);

  const handleStandaloneSearch = async (term) => {
    if (!term) return;
    setIsLoading(true);
    setIsSearchActive(true);
    try {
      const response = await nodeinstance.get(
        `/iqama/getFilterEmployeesforIqama/${term}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data) {
        setSearchData(response.data.data || []);
      }
    } catch (error) {
      dispatch(setAppError({ msg: "Search failed: " + error.message }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    if (!value) {
      setIsSearchActive(false);
      setSearchData(null);
    }
  };

  const handleSelectionChange = useCallback((emp_id, isChecked, row) => {
    setSelectedIds((prev) => {
      if (isChecked) return [...prev, emp_id];
      return prev.filter((id) => id !== emp_id);
    });
    setSelectedRows((prev) => {
      if (isChecked) return [...prev, row];
      return prev.filter((r) => r.emp_id !== emp_id);
    });
  }, []);

  const renderCustomCell = (item, column) => {
    if (column.key === "selection") {
      return (
        <input
          type="checkbox"
          checked={selectedIds.includes(item.emp_id)}
          onChange={(e) => handleSelectionChange(item.emp_id, e.target.checked, item)}
        />
      );
    }
    if (column.key === "status") {
      return item.iqama_status_value?.toString() === "5" ||
             item.iqama_status_value?.toString() === "3"
        ? "Iqama Tenure Pending"
        : item.Iqamma_Sadaad === "Iqamma Renew Done"
          ? item.iqama_status
          : item.iqama_status_value === 8
            ? "Iqama Renewal Pending"
            : item.iqama_status || "-";
    }
    if (column.key === "sadaad_notes") {
      return (
        <div className="max-w-[250px]">
          <span className="line-clamp-2" title={item.sadaad_notes}>
            {item.sadaad_notes || "-"}
          </span>
        </div>
      );
    }
    return null;
  };

  const PopOpen = (isRenew) => {
    if (selectedIds.length === 0) {
      dispatch(setAppError({ msg: "Please select Check box" }));
      return;
    }

    if (isRenew) {
      const hasTenure = selectedRows.some(row => row.tenure);
      if (hasTenure) {
        setPopUp(true);
      } else {
        setPopUp(true); // Assuming the popup handles the missing tenure
      }
    } else {
      const allApplied = selectedRows.every(row => row.tenure !== null);
      if (!allApplied) {
        dispatch(setAppError({ msg: "Please first Apply Renew" }));
      } else {
        setAuthPopup(true);
      }
    }
  };

  const apiCall = () => {
    setSelectedIds([]);
    setSelectedRows([]);
    setTrigger(prev => !prev);
    if (callBack) callBack();
  };

  const apiEndpoint = useMemo(() => {
    const params = new URLSearchParams();
    if (selectVisaProvider) params.append("visa_provider", selectVisaProvider);
    if (selectedStatus) params.append("client", selectedStatus);
    if (selectNational) params.append("nationality", selectNational);
    if (expiryDays) params.append("iqama_valid_days", expiryDays);
    return `/iqama/GetFilterEmployees?${params.toString()}`;
  }, [selectVisaProvider, selectedStatus, selectNational, expiryDays]);

  const additionalActions = useMemo(() => [
    {
      label: "ReNew",
      onClick: () => PopOpen(true),
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    },
    {
      label: "AUTHORIZE",
      onClick: () => PopOpen(false),
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    },
    {
      label: "Clear Filter",
      onClick: () => {
        setSelectVisaProvider("");
        setSelectedStatus("");
        setSelectNational("");
        setExpiryDays("");
        setIsSearchActive(false);
        setSearchData(null);
      },
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    }
  ], [selectedIds, selectedRows]);

  const headerLeft = (
    <div className="flex gap-2 justify-end items-center whitespace-nowrap">
      <select
        className="select select-sm select-bordered uppercase h-10 w-48"
        value={expiryDays}
        onChange={(e) => setExpiryDays(e.target.value)}
      >
        <option value=""> {"IQama Expiry days"}</option>
        {[{ value: "15" }, { value: "30" }].map((v) => (
          <option key={v.value} value={v.value}>{v.value}</option>
        ))}
      </select>
      <FilterDropDown
        onChange={(e) => setSelectVisaProvider(e.target.value)}
        title={"Visa Provider"}
        url={`/sadaad/visa-providers/`}
        token={token}
        selectedStatus={selectVisaProvider}
      />
      <FilterDropDown
        onChange={(e) => setSelectedStatus(e.target.value)}
        title={"Client"}
        url={`/sadaad/clients`}
        token={token}
        selectedStatus={selectedStatus}
      />
      <FilterDropDown
        onChange={(e) => setSelectNational(e.target.value)}
        title={"Nationality"}
        url={`/sadaad/Nationality`}
        token={token}
        selectedStatus={selectNational}
      />
    </div>
  );

  return (
    <>
      <div className="mt-4">
        <SmartDownloadPagination
          apiEndpoint={apiEndpoint}
          downloadEndpoint="/iqama/downloadRenewExcel"
          downloadFilename="Iqama_Renew_180_Days_Report"
          token={token}
          columns={columns}
          layoutType="table"
          additionalActions={additionalActions}
          headerLeft={headerLeft}
          renderCustomCell={renderCustomCell}
          searchPlaceholder={"Search employee id..."}
          defaultPageSize={50}
          pageSizeOptions={[10, 50, 100, 500, 1000]}
          trigger={trigger}
          onSearchClick={handleStandaloneSearch}
          onSearchChange={handleSearchChange}
          manualData={isSearchActive ? searchData : null}
          enableDownload={true}
        />
      </div>

      {Popup && (
        <ReNewPopUpUpdate
          list={selectedIds}
          token={token}
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"UPDATE RENEWAL TENURE"}
          url={"/iqama/updateTenure"}
          callBack={apiCall}
        />
      )}
      {authPopup && (
        <AuthorizationPopUp
          PopUp={authPopup}
          setPopUp={setAuthPopup}
          title={"UPDATE RENEWAL TENURE"}
          url={"/iqama/Authorize"}
          list={selectedRows}
          callBack={apiCall}
        />
      )}
      {documentPopUp && (
        <DocumentsDownloadPopup
          empData={empData}
          PopUp={documentPopUp}
          setPopUp={setDocumentPopUp}
          title={"Upload Border Number"}
          url={"/iqama/updatestatus"}
          list={documents}
        />
      )}
    </>
  );
}
